// extracted by mini-css-extract-plugin
export var standaloneTable = "_1l-0";
export var standaloneTableWithBodyFill = "_1l-1";
export var withExtraHeader = "_1l-2";